<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  class="bv-policy-dialog"
  [loading]="loading()"
>
  <span bitDialogTitle class="bv-policy-dialog__title">
    {{ "editPolicy" | i18n }}
    @if (!loading()) {
      <span class="bv-policy-dialog__subtitle">{{ policy.name | i18n }}</span>
    }
  </span>
  <ng-container bitDialogContent>
    @if (loading()) {
      <div>
        <i
          class="bwi bwi-spinner bwi-spin tw-text-muted"
          title="{{ 'loading' | i18n }}"
          aria-hidden="true"
        ></i>
        <span class="tw-sr-only">{{ "loading" | i18n }}</span>
      </div>
    }
    <div [hidden]="loading()">
      @if (policy.showDescription) {
        <p class="bv-policy-dialog__intro">{{ policy.description | i18n }}</p>
      }
      <ng-template #policyForm></ng-template>
    </div>
  </ng-container>
  <ng-container bitDialogFooter>
    <div class="bv-policy-dialog__footer">
      <button
        bitButton
        buttonType="secondary"
        type="button"
        class="bv-policy-dialog__cancel-btn"
        (click)="cancel()"
      >
        {{ "cancel" | i18n }}
      </button>
      <button
        bitButton
        buttonType="primary"
        [disabled]="saveDisabled()"
        bitFormButton
        type="submit"
      >
        {{ "save" | i18n }}
      </button>
    </div>
  </ng-container>
</form>
